import * as React from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {mh, p, pb, pt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    title: string;
    text?: string | React.ReactNode;
    children?: React.ReactNode;
    className?: string;
}

export const ResponsiveTableRow = (props: IProps) => {
    return (
        <ResponsiveTableRowBase className={props.className}>
            <Text variant="body_copy_1" css={responsiveTableRowTitle}>
                {props.title}
            </Text>

            <div css={descriptionStyles}>
                {props.text && (
                    <Text variant="body_copy_2" as="div">
                        {props.text}
                    </Text>
                )}
                {props.children && props.children}
            </div>
        </ResponsiveTableRowBase>
    );
};

const ResponsiveTableRowBase = styled.div`
    ${pt()}
    ${pb()}
    display: flex;
    flex-direction: column;
    align-items: baseline;
    white-space: pre-line;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray[200]};

    @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
        ${mh(4)}
        flex-direction: row;
        align-items: center;
    }

    &:last-of-type {
        border-bottom: 0 none;
    }
`;

const responsiveTableRowTitle = (theme: Theme) => css`
    ${pb()}
    flex: 0 0 100%;
    font-weight: 400;
    color: ${theme.colors.gray[700]};

    @media (min-width: ${theme.breakpoints.sm}) {
        min-width: 35%;
        flex: 0 0 35%;
        ${p(3, 2, 2, 0)};
    }
`;

const descriptionStyles = css`
    flex: 0 1 100%;
`;
import * as React from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {mh, p, pb, pt} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    title: string;
    text?: string | React.ReactNode;
    children?: React.ReactNode;
    className?: string;
}

export const ResponsiveTableRow = (props: IProps) => {
    return (
        <ResponsiveTableRowBase className={props.className}>
            <Text variant="body_copy_1" css={responsiveTableRowTitle}>
                {props.title}
            </Text>

            <div css={descriptionStyles}>
                {props.text && (
                    <Text variant="body_copy_2" as="div">
                        {props.text}
                    </Text>
                )}
                {props.children && props.children}
            </div>
        </ResponsiveTableRowBase>
    );
};

const ResponsiveTableRowBase = styled.div`
    ${pt()}
    ${pb()}
    display: flex;
    flex-direction: column;
    align-items: baseline;
    white-space: pre-line;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray[200]};

    @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
        ${mh(4)}
        flex-direction: row;
        align-items: center;
    }

    &:last-of-type {
        border-bottom: 0 none;
    }
`;

const responsiveTableRowTitle = (theme: Theme) => css`
    ${pb()}
    flex: 0 0 100%;
    font-weight: 400;
    color: ${theme.colors.gray[700]};

    @media (min-width: ${theme.breakpoints.sm}) {
        min-width: 35%;
        flex: 0 0 35%;
        ${p(3, 2, 2, 0)};
    }
`;

const descriptionStyles = css`
    flex: 0 1 100%;
`;
